import { render, staticRenderFns } from "./uipay.vue?vue&type=template&id=00987268&"
import script from "./uipay.vue?vue&type=script&lang=js&"
export * from "./uipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports